import apiClient from './client'

export interface TranscribeResponse {
  text: string
  duration: number
}

export const transcribeApi = {
  /**
   * POST /api/v1/assistants/{assistantId}/transcribe
   * Sends audio blob for speech-to-text transcription.
   */
  transcribe: async (assistantId: string, audioBlob: Blob): Promise<TranscribeResponse> => {
    const formData = new FormData()
    // Determine extension from MIME type
    const ext = audioBlob.type.includes('ogg') ? 'ogg' : audioBlob.type.includes('webm') ? 'webm' : 'wav'
    formData.append('audio', audioBlob, `voice.${ext}`)

    const response = await apiClient.post<TranscribeResponse>(
      `/assistants/${assistantId}/transcribe`,
      formData
    )
    return response.data
  },
}
